import { distributionAccountActions } from "./accounts/actions";
import { distributionOrderActions } from "./orders/actions";
import { importsActions } from "./imports/actions";
import { distributionStatementsActions } from "./statement/actions";
import { distributionSupplierActions } from "./suppliers/actions";
import { shopsDistributionActions } from "./shops/actions";
import { reportsDistributionActions } from "./reports/actions";
import { shop_groupsDistributionActions } from "./shop_groups/actions";
import { DistributionModulePluginStore } from "./plugin-store";
import { distributionSupplierOrderActions } from "./supplier_orders/actions";
import { distributionReleaseReportActions } from "./release_report/actions";

export const actions = {
  ...importsActions,
  ...distributionAccountActions,
  ...distributionOrderActions,
  ...distributionSupplierActions,
  ...distributionStatementsActions,
  ...shopsDistributionActions,
  ...shop_groupsDistributionActions,
  ...reportsDistributionActions,
  ...distributionSupplierOrderActions,
  ...distributionReleaseReportActions,
  ...DistributionModulePluginStore.actions
};
